import {ReactNode, useContext} from "react";
import ClickableLink from "../../utilities/ClickableLink";
import {StoreContext} from "../../../stores/StoreLoader";
import styles from "./styles/SearchResultFooter.module.scss";

export default function SearchResultFooter(props: {
    url: string,
    parentText: string,
    parentType: string,
    cssWidthClass: string,
    cssColorClass: string,
    grandParentText?: string,
    blockObj: AnyBlockObj,
}) {
    const {modalStore} = useContext(StoreContext);
    const { url, parentText, parentType, grandParentText, cssColorClass, cssWidthClass } = props;

    let grandParent: null | ReactNode = null;
    if (grandParentText) {
        grandParent = <div className={`${styles.searchFooterGrandparentText} ${cssWidthClass}`}>{grandParentText}</div>
    }

    const content = <div className={styles.searchFooter} data-parent-type={parentType}>
        <div className={styles.searchFooterTable}>
            <div className={styles.searchFooterParentText}>{parentText}</div>
            { grandParent }
        </div>
    </div>

    if (props.blockObj.filterBlockType === "staff") {
        return <button onClick={() => modalStore.addModal({
            id: props.blockObj.blockModel.id,
            type: "schoolBlocksPerson",
            blockObj: props.blockObj,
        })}>
            {content}
        </button>
    } else {
        return <ClickableLink href={url}>
            {content}
        </ClickableLink>
    }
}